import React, { FC } from 'react'
import * as StyledProductList from './productList.styles'
import StorefrontProduct from '@local-types/products/storefrontProduct'
import ProductBox from '../productBoxes/productBox'
import ProductBoxLoader from '../productBoxes/productBox/productBoxLoader'
import styled from 'styled-components'
import { P } from 'components/base/typography/misc'

const EmptyText = styled(P)`
	width: 100%;
	text-align: center;
`

interface Props {
	products: StorefrontProduct[]
	loading: boolean
	error: boolean
	empty: boolean
}

const ProductList: FC<Props> = ({ loading, products, error, empty }) => {
	if (error) {
		return <div>error</div>
	}

	if (empty) {
		return <EmptyText>Engar vörur fundust</EmptyText>
	}

	return (
		<StyledProductList.Wrapper>
			<StyledProductList.ListWrapper>
				{loading &&
					[...Array(8)].map((key, index) => (
						<StyledProductList.ListColumn key={`loader-${index}`}>
							<ProductBoxLoader />
						</StyledProductList.ListColumn>
					))}
				{!loading &&
					products.map((prod, index) => (
						<StyledProductList.ListColumn key={`${prod.id}-${index}`}>
							<ProductBox product={prod} />
						</StyledProductList.ListColumn>
					))}
			</StyledProductList.ListWrapper>
		</StyledProductList.Wrapper>
	)
}

export default ProductList
